var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    {
      attrs: {
        appBarTitle: _vm.$tr("editSyncScheduleTitle"),
        route: _vm.goBackRoute,
        icon: _vm.icon,
      },
    },
    [
      _vm.device
        ? _c(
            "KPageContainer",
            { style: _vm.pageHeight },
            [
              _c(
                "KGrid",
                { staticClass: "edit-sync-schedule", attrs: { gutter: "48" } },
                [
                  _c("KGridItem", [
                    _c("h1", [
                      _vm._v(_vm._s(_vm.$tr("editSyncScheduleTitle"))),
                    ]),
                  ]),
                  _c("KGridItem", [
                    _c("p", [_vm._v(_vm._s(_vm.device.device_name) + " ")]),
                  ]),
                  _c(
                    "KGrid",
                    { staticClass: "align-kselects" },
                    [
                      _c(
                        "KGrid",
                        [
                          _c(
                            "KGridItem",
                            [
                              _c("KSelect", {
                                staticClass: "selector",
                                style: _vm.selectorStyle,
                                attrs: {
                                  disabled: _vm.currentTaskRunning,
                                  options: _vm.selectArray,
                                  label: _vm.$tr("frequency"),
                                },
                                model: {
                                  value: _vm.selectedItem,
                                  callback: function ($$v) {
                                    _vm.selectedItem = $$v
                                  },
                                  expression: "selectedItem",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.dayRequired
                        ? _c(
                            "KGrid",
                            [
                              _c(
                                "KGridItem",
                                [
                                  _c("KSelect", {
                                    staticClass: "selector",
                                    style: _vm.selectorStyle,
                                    attrs: {
                                      disabled: _vm.currentTaskRunning,
                                      options: _vm.getDays,
                                      label: _vm.$tr("day"),
                                    },
                                    model: {
                                      value: _vm.selectedDay,
                                      callback: function ($$v) {
                                        _vm.selectedDay = $$v
                                      },
                                      expression: "selectedDay",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.timeRequired
                        ? _c(
                            "KGrid",
                            [
                              _c(
                                "KGridItem",
                                [
                                  _c("KSelect", {
                                    staticClass: "selector",
                                    style: _vm.selectorStyle,
                                    attrs: {
                                      disabled: _vm.currentTaskRunning,
                                      options: _vm.SyncTime,
                                      label: _vm.$tr("time"),
                                    },
                                    model: {
                                      value: _vm.selectedTime,
                                      callback: function ($$v) {
                                        _vm.selectedTime = $$v
                                      },
                                      expression: "selectedTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("KGridItem", [
                    _c("p", { staticClass: "spacing" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tr("serverTime")) +
                          "\n          " +
                          _vm._s(
                            _vm.$formatTime(_vm.now, {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              second: "numeric",
                            })
                          ) +
                          "\n        "
                      ),
                    ]),
                    _c(
                      "p",
                      { staticClass: "spacing" },
                      [
                        _c(
                          "KCheckbox",
                          {
                            attrs: {
                              checked: _vm.retryFlag,
                              disabled: _vm.currentTaskRunning,
                            },
                            on: {
                              change: function ($event) {
                                _vm.retryFlag = !_vm.retryFlag
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$tr("checkboxLabel")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "p",
                      [
                        _vm.currentTask
                          ? _c(
                              "KButton",
                              {
                                staticClass: "spacing",
                                attrs: {
                                  disabled: _vm.currentTaskRunning,
                                  appearance: "basic-link",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.removeDeviceModal = true
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$tr("removeDeviceLabel")) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "BottomAppBar",
        [
          _c(
            "KButtonGroup",
            [
              _c("KButton", {
                attrs: {
                  text: _vm.coreString("cancelAction"),
                  appearance: "flat-button",
                },
                on: { click: _vm.goBack },
              }),
              _c("KButton", {
                attrs: {
                  text: _vm.coreString("saveAction"),
                  primary: true,
                  disabled: _vm.saveDisabled,
                },
                on: { click: _vm.handleSaveSchedule },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.removeDeviceModal
        ? _c(
            "KModal",
            {
              attrs: {
                title: _vm.$tr("removeDevice"),
                size: "medium",
                submitText: _vm.coreString("removeAction"),
                cancelText: _vm.coreString("cancelAction"),
              },
              on: { cancel: _vm.closeModal, submit: _vm.handleDeleteDevice },
            },
            [
              _c(
                "KGrid",
                [
                  _c(
                    "KGridItem",
                    { attrs: { layout8: { span: 6 }, layout12: { span: 10 } } },
                    [_c("p", [_vm._v(_vm._s(_vm.deviceName))])]
                  ),
                  _c(
                    "KGridItem",
                    { attrs: { layout8: { span: 8 }, layout12: { span: 12 } } },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.$tr("removeDeviceWarning")))]),
                      !_vm.device.available
                        ? _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$tr("deviceNotConnected")) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }